import { Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationFiscalityRentFormBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options) {
    this.options = options;
    return this.formBuilder.group(
      {
        addressStreet: [
          this.entity.realEstateParameters.address.street
            ? entity.realEstateParameters.address.street
            : null,
          Validators.required,
        ],
        addressZipCode: [
          this.entity.realEstateParameters.address.zipCode
            ? entity.realEstateParameters.address.zipCode
            : null,
          Validators.required,
        ],
        addressCity: [
          this.entity.realEstateParameters.address.city
            ? entity.realEstateParameters.address.city
            : null,
          Validators.required,
        ],
        propertyType: this.entity.realEstateParameters.propertyType
          ? entity.realEstateParameters.propertyType
          : null,
        propertyValue: [
          this.entity.realEstateParameters.propertyValue
            ? entity.realEstateParameters.propertyValue
            : null,
          Validators.required,
        ],
        areaSize: [
          this.entity.realEstateParameters.areaSize
            ? entity.realEstateParameters.areaSize
            : null,
          Validators.required,
        ],
        rent: [
          this.entity.realEstateParameters.rent
            ? entity.realEstateParameters.rent
            : null,
          Validators.required,
        ],
        furnitureValue: [
          this.entity.realEstateParameters.furnitureValue
            ? entity.realEstateParameters.furnitureValue
            : null,
          Validators.required,
        ],
        workAmount: this.entity.realEstateParameters.workAmount
          ? entity.realEstateParameters.workAmount
          : null,
        fiscalityLawType: 'FONCIER',
        cashOrCredit: [
          entity ? entity.realEstateParameters.cashOrCredit : null,
          [
            this.prFormService.RefreshEveryValidators([
              'loanDuration',
              'borrowedAmount',
              'loanInterestRate',
              'loanInsuranceRate',
            ]),
          ],
        ],
        loanDuration: [
          entity ? entity.realEstateParameters.loanDuration : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        borrowedAmount: [
          entity ? entity.realEstateParameters.borrowedAmount : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        loanInterestRate: [
          entity.realEstateParameters.loanInterestRate
            ? this.roundNumber(
                entity.realEstateParameters.loanInterestRate * 100,
              )
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        annualyInsurance: [
          entity.realEstateParameters.annualyInsurance
            ? entity.realEstateParameters.annualyInsurance
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        loanStartDate: [
          entity.realEstateParameters.loanStartDate
            ? entity.realEstateParameters.loanStartDate
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        agencyFees: [
          this.entity.realEstateParameters.agencyFees
            ? entity.realEstateParameters.agencyFees
            : null,
          Validators.required,
        ],
        propertyTax: this.entity.realEstateParameters.propertyTax
          ? entity.realEstateParameters.propertyTax
          : null,
        annuallyCharge: this.entity.realEstateParameters.annuallyCharge
          ? entity.realEstateParameters.annuallyCharge
          : null,
        otherFees: this.entity.realEstateParameters.otherFees
          ? entity.realEstateParameters.otherFees
          : null,
      },
      options,
    );
  }

  roundNumber(value) {
    return Math.round(value * 100) / 100;
  }

  extract() {
    return {
      realEstateParameters: {
        address: {
          label:
            this.emptyIsNull(this.form.value.addressStreet) +
            ', ' +
            this.emptyIsNull(this.form.value.addressZipCode) +
            ', ' +
            this.emptyIsNull(this.form.value.addressCity),
          street: this.emptyIsNull(this.form.value.addressStreet),
          zipCode: this.emptyIsNull(this.form.value.addressZipCode),
          city: this.emptyIsNull(this.form.value.addressCity),
        },
        propertyType: this.emptyIsNull(this.form.value.propertyType),
        fiscalityLawType: this.emptyIsNull(this.form.value.fiscalityLawType),
        rent: this.emptyIsNull(this.form.value.rent),
        propertyValue: this.emptyIsNull(this.form.value.propertyValue),
        areaSize: this.emptyIsNull(this.form.value.areaSize),
        furnitureValue: this.emptyIsNull(this.form.value.furnitureValue),
        workAmount: this.emptyIsNull(this.form.value.workAmount),
        cashOrCredit: this.emptyIsNull(this.form.value.cashOrCredit),
        borrowedAmount: this.emptyIsNull(this.form.value.borrowedAmount),
        loanInterestRate: this.emptyIsNull(
          this.form.value.loanInterestRate / 100,
        ),
        annualyInsurance: this.emptyIsNull(this.form.value.annualyInsurance),
        loanDuration: this.emptyIsNull(this.form.value.loanDuration),
        loanStartDate: this.emptyIsNull(
          new Date(this.form.value.loanStartDate).toISOString().split('.')[0] +
            'Z',
        ),
        agencyFees: this.form.value.agencyFees,
        notaryFees: 0.07,
        propertyTax: this.emptyIsNull(this.form.value.propertyTax),
        annuallyCharge: this.emptyIsNull(this.form.value.annuallyCharge),
        otherFees: this.emptyIsNull(this.form.value.otherFees),
      },
    };
  }
}
